export enum PredefinedStoreName {

    CONFIG = "configStore",

    CONTEXT = "contextStore",

    NAVIGATION = "navigationStore",

    NOTIFICATION = "notificationStore",

    PANEL = "panelStore",
}
